export interface IconProps {
  name: string,
  title?: string,
  className?: string,
  style?: Object
}

const Icon = (props: IconProps) => {
  return (
    <span
      className={`material-symbols-outlined ${props.className || ""}`}
      title={props.title}
      style={props.style}
    >
      {props.name}
    </span>
  )
}

export default Icon
